// extracted by mini-css-extract-plugin
module.exports = {"sendcode":"setCreditModal_sendcode__1nxOM","from":"setCreditModal_from__1Xjiz","Switch":"setCreditModal_Switch__13N0P"};